<template>
    <label class="tw:block tw:text-sm tw:font-medium tw:text-gray-700 tw:mb-1.5">
        <slot>{{ title }}</slot>
        <span v-if="required" class="tw:text-red-500 tw:ml-0.5">*</span>
    </label>
</template>

<script>
export default {
    name: 'BaseLabel',
    props: {
        title: {
            type: String,
            default: ''
        },
        required: {
            type: Boolean,
            default: false
        }
    }
}
</script>